/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/*
* localconfig.ts — test.dynalearn.nl
* Buiten git; zie localconfig.ts.example ernaast en sihw-ngx/src/lib/localconfig/readme.md
*
* Sinds golf a6 bezit ng21 de socket: de backend-url en de auth-instellingen staan hier
*/

export const localconfig = {
    "SIHW": {
        "sihwlog": {
            "logging": true,
            "minLevel": "debug",
            "defaultLevel": "warn"
        },
        "SpinJS": {
            "url": "https://testapi.dynalearn.nl",
            //dezelfde sleutel en persistentie als de oude ng1-client, zodat een lopende sessie
            //de omzetting overleeft
            "storeKey": "spinjs2",
            "authPersistence": "storage",
            "logLevel": "debug"
        }
    }
};
